import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const AIAutomation = () => {

  const projects = [
    {
      title: "AI Chatbot System",
      desc: "Automated support system.",
      link: "#",
    },
  ];

  const testimonials = [
    {
      name: "Usman Shah",
      role: "Business Owner",
      feedback: "Saved hours of work.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-cyan-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Smart <span className="text-cyan-400">AI Automation</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Automate workflows and scale your business with intelligent AI systems.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-cyan-500 rounded-full">
              Automate Now
            </Link>

            <a href="https://calendly.com/thelogicwaves/30min"
              className="px-8 py-4 border rounded-full">
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* WHAT WE BUILD */}
      <section className="py-24 px-6 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {[
          "AI Chatbots",
          "Workflow Automation",
          "CRM Automation",
          "Lead Automation",
          "AI Integrations",
          "Custom AI Tools",
        ].map((item, i) => (
          <div key={i} className="bg-white/5 p-6 rounded-xl">
            <h3 className="text-cyan-400">{item}</h3>
          </div>
        ))}
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-cyan-500 to-blue-500">
        <h2 className="text-4xl font-bold mb-6">
          Automate Your Growth 🚀
        </h2>
        <Link to="/contact" className="bg-black px-6 py-3 rounded">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default AIAutomation;